<template>
  <div class="mx-auto" style="width: 1500px;">
    <form id="part-maintenance">
      <b-tabs>
        <b-tab active title="Part Details">
          <b-card no-body class="mb-1">
            <b-card-header v-if="quickForm">
                <b-row>
                  <b-col cols="5">
                    <b-form-group label="Use existing part information:" >
                      <vue-simple-suggest
                          class="suggest-input form-control"
                          :styles="autoCompleteStyle"
                          :list="getList"
                          v-model="chosenPartNumber"
                          :max-suggestions="20"
                          :min-length="2"
                          :debounce="750"
                          :filter-by-query="true"
                          value-attribute="id"
                          display-attribute="partNumber"
                          placeholder="Enter existing part number and select..."
                          @select="onSuggestSelect"
                          @input="isLoadingPart = true"
                          @request-done="isLoadingPart = false"
                        >
                        <div slot="misc-item-below" v-if="isLoadingPart" class="misc-item">
                          <span>Loading Part...</span>
                        </div>
                      </vue-simple-suggest>
                    </b-form-group>
                  </b-col>
                </b-row>
            </b-card-header>
            <b-card-body>
              <div class="mb-2" style="display: grid; grid-template-rows: repeat(6, 1fr); grid-template-columns: repeat(4, 1fr); grid-column-gap: 0.75rem; grid-row-gap: 0.5rem">
                <b-form-group label="Part #" class="required" style="grid-column: 1;">
                  <b-form-input
                    ref="partNumberInput"
                    v-model="partLocal.partNumber"
                    :class="{ 'is-invalid': $v.partLocal.partNumber.$error }"
                    @blur="$v.partLocal.partNumber.$touch()"
                    @input="$emit('update:partNumber', partLocal.partNumber)"
                  ></b-form-input>

                  <div class="invalid-feedback">
                    <div v-if="!$v.partLocal.partNumber.required">Part number is required</div>
                  </div>
                </b-form-group>

                <b-form-group label="Alternate PN" style="grid-column: 1;">
                  <b-form-input v-model="partLocal.altNumber"></b-form-input>
                </b-form-group>

                <b-form-group label="Internal PN" style="grid-column: 1;">
                  <b-form-input v-model="partLocal.internalPN"></b-form-input>
                </b-form-group>

                <b-form-group label="NSN" style="grid-column: 1;">
                  <b-form-input v-model="partLocal.nsnNumber"></b-form-input>
                </b-form-group>

                <b-form-group label="SKU" style="grid-column: 1;">
                  <b-form-input v-model="partLocal.sku"></b-form-input>
                </b-form-group>

                <!-- <b-form-group class="d-flex justify-content-left align-items-center" style="grid-column: 1; margin-top: 2px">
                  <b-form-checkbox v-model="partLocal.isService"  >
                    Is Service?
                  </b-form-checkbox>
                </b-form-group> -->

                <b-form-group label="Description" class="required" style="grid-row: 1; grid-column: 2/5;">
                  <b-form-input
                    v-model="partLocal.description"
                    :class="{ 'is-invalid': $v.partLocal.description.$error }"
                    @blur="$v.partLocal.description.$touch()"
                  ></b-form-input>

                  <div class="invalid-feedback">
                    <div v-if="!$v.partLocal.description.required">Description is required</div>
                  </div>
                </b-form-group>

                <b-form-group label="Harmonized Code" style="grid-row: 2; grid-column: 2;">
                  <b-form-input v-model="partLocal.harmonizedCode"></b-form-input>
                </b-form-group>

                <b-form-group label="Schedule B No" style="grid-row: 2; grid-column: 3;">
                  <b-form-input v-model="partLocal.scheduleB"></b-form-input>
                </b-form-group>

                <b-form-group label="ECCN" style="grid-row: 2; grid-column: 4;">
                  <b-form-input v-model="partLocal.eccn"></b-form-input>
                </b-form-group>

                <b-form-group label="Mfr" class="required" style="grid-row: 3; grid-column: 2;">
                  <lookup-dropdown
                    label="manufacturer"
                    moduleName="manufacturers"
                    resource="inventoryManufacturer"
                    propKey="manufacturerId"
                    :value="partLocal.manufacturerId"
                    :isInvalid="$v.partLocal.manufacturerId.$error"
                    :options="manufacturers"
                    :overrideModalId="modalIdGenerator('manufacturer')"
                    @change="onValueChangePart"
                  />
                  <div class="invalid-feedback">
                    <div v-if="!$v.partLocal.manufacturerId.required">Manufacturer is required</div>
                  </div>
                </b-form-group>

                <b-form-group label="Class" class="required" style="grid-row: 3; grid-column: 3;">
                  <lookup-dropdown
                    label="class"
                    moduleName="classes"
                    resource="inventoryClass"
                    propKey="inventoryClassId"
                    :value="partLocal.inventoryClassId"
                    :isInvalid="$v.partLocal.inventoryClassId.$error"
                    :options="classes"
                    :overrideModalId="modalIdGenerator('class')"
                    @change="onValueChangePart"
                  />
                  <div class="invalid-feedback">
                    <div v-if="!$v.partLocal.inventoryClassId.required">Class is required</div>
                  </div>
                </b-form-group>

                <b-form-group label="Category" class="required" style="grid-row: 3; grid-column: 4;">
                  <!-- <b-form-select
                    v-model="partLocal.inventoryCategoryId"
                    :class="{ 'is-invalid': $v.partLocal.inventoryCategoryId.$error }"
                    @blur="$v.partLocal.inventoryCategoryId.$touch()"
                  >
                    <option
                      v-for="(category) in sortSelect(categories)"
                      :key="category.id"
                      :value="category.id"
                    >{{category.name}}</option>
                  </b-form-select> -->

                  <lookup-dropdown
                    label="category"
                    moduleName="categories"
                    resource="inventoryCategory"
                    propKey="inventoryCategoryId"
                    :value="partLocal.inventoryCategoryId"
                    :isInvalid="$v.partLocal.inventoryCategoryId.$error"
                    :options="categories"
                    :overrideModalId="modalIdGenerator('category')"
                    @change="onValueChangePart"
                  />

                  <div class="invalid-feedback">
                    <div v-if="!$v.partLocal.inventoryCategoryId.required">Inventory is required</div>
                  </div>
                </b-form-group>

                <b-form-group label="Packaging" class="required" style="grid-row: 4; grid-column: 2;">
                  <lookup-dropdown
                    label="packaging"
                    moduleName="packaging"
                    resource="inventoryPackaging"
                    propKey="packageId"
                    :value="partLocal.packageId"
                    :options="packaging"
                    :isInvalid="$v.partLocal.packageId.$error"
                    :overrideModalId="modalIdGenerator('packaging')"
                    @change="onValueChangePart"
                  />
                  <div class="invalid-feedback">
                    <div v-if="!$v.partLocal.packageId.required">Package is required</div>
                  </div>
                </b-form-group>


                <b-form-group label="SPQ" style="grid-row: 4; grid-column: 3;">
                  <b-form-input type="number" v-model="partLocal.piecePerPkg"></b-form-input>
                </b-form-group>

                <b-form-group label="Physical Package" style="grid-row: 4; grid-column: 4;">
                  <b-form-input v-model="partLocal.physPkg"></b-form-input>
                </b-form-group>

                <b-form-group label="Temp" style="grid-row: 5; grid-column: 2;">
                  <b-form-input v-model="partLocal.tempRating"></b-form-input>
                </b-form-group>

                <b-form-group label="RoHS" class="required" style="grid-row: 5; grid-column: 3;">
                  <b-form-select
                    v-model="partLocal.leadFree"
                    :class="{ 'is-invalid': $v.partLocal.leadFree.$error }"
                    @blur="$v.partLocal.leadFree.$touch()"
                  >
                    <option
                      v-for="(value) in leadFreeValues"
                      :key="value"
                      :value="value"
                    >{{value}}</option>
                  </b-form-select>

                  <div class="invalid-feedback">
                    <div v-if="!$v.partLocal.leadFree.required">RoHS is required</div>
                  </div>
                </b-form-group>

                <b-form-group label="UOM" class="required" style="grid-row: 5; grid-column: 4;">
                  <!-- <b-form-input v-model="partLocal.uoMId"></b-form-input> -->
                  <lookup-dropdown
                    label="UOM"
                    moduleName="uoms"
                    resource="inventoryUom"
                    propKey="uoMId"
                    :value="partLocal.uoMId"
                    :options="uoms"
                    :isInvalid="$v.partLocal.uoMId.$error"
                    :overrideModalId="modalIdGenerator('uom')"
                    @change="onValueChangePart"
                  />
                </b-form-group>
                <div class="invalid-feedback">
                    <div v-if="!$v.partLocal.uoMId.required">UOM is required</div>
                  </div>
                <b-form-group label="Comments" style="grid-row: 6; grid-column: 2/5;">
                  <b-form-input v-model="partLocal.comments"></b-form-input>
                </b-form-group>

                </div>
                <b-card no-body v-if="!quickForm">
                  <b-card-header header-tag="header" class="p-1" role="tab">
                    <b-button block v-b-toggle.more-part-details variant="secondary">More Details</b-button>
                  </b-card-header>
                  <b-collapse id="more-part-details" accordion="more-part-details" role="tabpanel">
                    <b-card-body>
                      <div style="display: grid; grid-template-rows: repeat(4, 1fr); grid-template-columns: repeat(4, 1fr); grid-column-gap: 0.75rem; grid-row-gap: 0.5rem">
                        <b-form-group label="Alt Mfr">
                          <b-form-select v-model="partLocal.altManufacturerId">
                            <option
                              v-for="(select, index) in sortSelect(manufacturers)"
                              :key="index"
                              :value="select.id"
                            >{{ select.name }}</option>
                          </b-form-select>
                        </b-form-group>

                        <b-form-group label="Size">
                          <b-form-input v-model="partLocal.size"></b-form-input>
                        </b-form-group>

                        <b-form-group label="Voltage" >
                          <b-form-input v-model="partLocal.voltage"></b-form-input>
                        </b-form-group>

                        <b-form-group label="Amperage">
                          <b-form-input v-model="partLocal.amperage"></b-form-input>
                        </b-form-group>

                        <b-form-group label="Resolution">
                          <b-form-input v-model="partLocal.resolution"></b-form-input>
                        </b-form-group>

                        <b-form-group label="Watts">
                          <b-form-input v-model="partLocal.watts"></b-form-input>
                        </b-form-group>

                        <b-form-group label="Backlighting">
                          <b-form-input v-model="partLocal.backlighting"></b-form-input>
                        </b-form-group>

                        <b-form-group label="Contrast Ratio">
                          <b-form-input v-model="partLocal.contrastRatio"></b-form-input>
                        </b-form-group>

                        <b-form-group label="Aspect Ratio" >
                          <b-form-input v-model="partLocal.aspectRatio"></b-form-input>
                        </b-form-group>

                        <b-form-group label="Oper Temp" >
                          <b-form-input v-model="partLocal.operTemp"></b-form-input>
                        </b-form-group>

                        <b-form-group label="Stor Temp" >
                          <b-form-input v-model="partLocal.storTemp"></b-form-input>
                        </b-form-group>

                        <b-form-group label="Polarizer Type" >
                          <b-form-input v-model="partLocal.polarizerType"></b-form-input>
                        </b-form-group>

                        <b-form-group label="Data Conn" >
                          <b-form-input v-model="partLocal.dataConn"></b-form-input>
                        </b-form-group>

                        <b-form-group label="BL Conn" >
                          <b-form-input v-model="partLocal.blConn"></b-form-input>
                        </b-form-group>
                      </div>
                    </b-card-body>
                  </b-collapse>
                </b-card>
                
              </b-card-body>
          </b-card>
        </b-tab>
        <b-tab title="Account Details" v-if="!quickForm">
          <b-card no-body class="mb-1">
            <b-card-body title="Cost/Resale">
              <div class="mb-2" style="display: grid; grid-template-rows: repeat(2, 1fr); grid-template-columns: repeat(3, 1fr); grid-column-gap: 0.75rem; grid-row-gap: 0.5rem;">
                <b-form-group label="Asset Account Name" style="grid-row: 1; grid-column: 1;">
                  <!-- <b-form-input v-model="partLocal.assetAccountId"></b-form-input> -->
                  <b-form-select v-model="partLocal.assetAccountId">
                    <option
                      v-for="(account) in sortSelect(assetChartsAccounts,'accountName')"
                      :key="account.id"
                      :value="account.id"
                    >{{account.accountName}}</option>
                  </b-form-select>
                </b-form-group>

                <b-form-group label="Expense Account Name" style="grid-row: 1; grid-column: 2;">
                  <!-- <b-form-input v-model="partLocal.expenseAccountId"></b-form-input> -->
                  <b-form-select v-model="partLocal.expenseAccountId">
                    <option
                      v-for="(account) in sortSelect(expenseChartsAccounts,'accountName')"
                      :key="account.id"
                      :value="account.id"
                    >{{account.accountName}}</option>
                  </b-form-select>
                </b-form-group>

                <b-form-group label="Income Account Name" style="grid-row: 1; grid-column: 3;">
                  <!-- <b-form-input v-model="partLocal.incomeAccountId"></b-form-input> -->
                  <b-form-select v-model="partLocal.incomeAccountId">
                    <option
                      v-for="(account) in sortSelect(incomeChartAccounts,'accountName')"
                      :key="account.id"
                      :value="account.id"
                    >{{account.accountName}}</option>
                  </b-form-select>
                </b-form-group>

                <b-form-group label="Cost" style="grid-row: 2; grid-column: 1;">
                  <b-form-input type="number" v-model="partLocal.cost"></b-form-input>
                </b-form-group>

                <b-form-group label="List Price" style="grid-row: 2; grid-column: 2;">
                  <b-form-input type="number" v-model="partLocal.listPrice"></b-form-input>
                </b-form-group>

                <b-form-group label="Resale" style="grid-row: 2; grid-column: 3;">
                  <b-form-input type="number" v-model="partLocal.resale"></b-form-input>
                </b-form-group>
              </div>
            </b-card-body>
            <b-card-body title="Discount Levels">
              <div class="mb-2" style="display: grid; grid-template-rows: repeat(4, 1fr); grid-template-columns: repeat(3, 1fr); grid-column-gap: 0.75rem; grid-row-gap: 0.5rem;">
                <b-form-group label="Discount Level 1" style="grid-row: 1; grid-column: 1;">
                  <b-form-input type="number" v-model="partLocal.discount1"></b-form-input>
                </b-form-group>
                <b-form-group label="Qty Required" style="grid-row: 1; grid-column: 2;">
                  <b-form-input type="number" v-model="partLocal.qtyRequired1"></b-form-input>
                </b-form-group>
                <b-form-group label="Price" style="grid-row: 1; grid-column: 3;">
                  <b-form-input type="number" v-model="partLocal.price1"></b-form-input>
                </b-form-group>
                <b-form-group label="Discount Level 2" style="grid-row: 2; grid-column: 1;">
                  <b-form-input type="number" v-model="partLocal.discount2"></b-form-input>
                </b-form-group>
                <b-form-group label="Qty Required" style="grid-row: 2; grid-column: 2;">
                  <b-form-input type="number" v-model="partLocal.qtyRequired2"></b-form-input>
                </b-form-group>
                <b-form-group label="Price" style="grid-row: 2; grid-column: 3;">
                  <b-form-input type="number" v-model="partLocal.price2"></b-form-input>
                </b-form-group>
                <b-form-group label="Discount Level 3" style="grid-row: 3; grid-column: 1;">
                  <b-form-input type="number" v-model="partLocal.discount3"></b-form-input>
                </b-form-group>
                <b-form-group label="Qty Required" style="grid-row: 3; grid-column: 2;">
                  <b-form-input type="number" v-model="partLocal.qtyRequired3"></b-form-input>
                </b-form-group>
                <b-form-group label="Price" style="grid-row: 3; grid-column: 3;">
                  <b-form-input type="number" v-model="partLocal.price3"></b-form-input>
                </b-form-group>
                <b-form-group label="Discount Level 4" style="grid-row: 4; grid-column: 1;">
                  <b-form-input type="number" v-model="partLocal.discount4"></b-form-input>
                </b-form-group>
                <b-form-group label="Qty Required" style="grid-row: 4; grid-column: 2;">
                  <b-form-input type="number" v-model="partLocal.qtyRequired4"></b-form-input>
                </b-form-group>
                <b-form-group label="Price" style="grid-row: 4; grid-column: 3;">
                  <b-form-input type="number" v-model="partLocal.price4"></b-form-input>
                </b-form-group>
              </div>
            </b-card-body>
          </b-card>
        </b-tab>
      </b-tabs>
      <div class="mt-2">
        <b-button v-if="checkClaim(CAN_EDIT_PARTS)" class="mr-2" variant="primary" @click="onSave" :disabled="isSaving">
          <i v-if="isSaving" class="fa fa-spinner fa-pulse fa-fw mr-1"></i>Save</b-button>
        <b-button v-if="checkClaim(CAN_EDIT_PARTS) && partLocal.id > 0" @click="onCopy" class="mr-2" variant="warning">Copy</b-button>
        <b-button v-if="checkClaim(CAN_VIEW_PARTS)" @click="onCancel">Cancel</b-button>
      </div>
    </form>
  </div>
</template>

<script>
/****************************************************************************************************
*****************************************************************************************************
*****************************************************************************************************
*****************************************************************************************************
*****************************************************************************************************
*****************************************************************************************************/
import { mapState, mapGetters, mapActions } from 'vuex';
import { LEAD_FREE_VALUES, AUTO_COMPLETE_STYLES } from '@/shared/constants';
import { required } from 'vuelidate/lib/validators';
import VueSimpleSuggest from 'vue-simple-suggest';

export default {
  components: {
    VueSimpleSuggest
  },
  props: {
    partId: {
      type: [Number, String],
      default: 0,
    },
    // part: {
    //   type: Object,
    //   default: () => ( {} ),
    // },
    saveFunction: {
      type: Function,
      default: () => {},
    },
    partNumberProp: {
      type: String,
      default: ''
    },
    propForm: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      leadFreeValues: LEAD_FREE_VALUES,
      partLocal: {},
      assetChartAccountIds: [8, 12],
      expenseChartAccountIds: [7, 14],
      incomeChartAccountIds: [9, 15],
      isSaving: false,
      autoCompleteStyle: AUTO_COMPLETE_STYLES,
      isLoadingPart: false,
      selectedPart: {},
      chosenPartNumber: null
    }
  },
  computed: {
    ...mapGetters('parts', [
      'part',
    ]),
    ...mapGetters('lookup', [
      'manufacturers',
      'conditions',
      'packaging',
      'classes',
      'categories',
      'uoms',
      'chartAccounts'
    ]),
    ...mapGetters('requirementAdd', ['partNumbers']),
    quickForm() {
      return this.partId == 0;
    },
    assetChartsAccounts() {
      return this.chartAccounts.filter(x => this.assetChartAccountIds.includes(x.accountTypeId));
    },
    expenseChartsAccounts() {
      return this.chartAccounts.filter(x => this.expenseChartAccountIds.includes(x.accountTypeId));
    },
    incomeChartAccounts() {
      return this.chartAccounts.filter(x => this.incomeChartAccountIds.includes(x.accountTypeId));
    }
  },
  methods: {
    ...mapActions('parts', [
      'getById',
      'createPart',
      'updatePart',
    ]),
    ...mapActions('requirementAdd', ['getPartNumbers']),
    async onSave() {
      this.$v.$touch();
      if(!this.$v.$invalid){
        try {
          this.isSaving = true;
          if (this.partLocal.id === undefined || this.partLocal.id === null || this.partLocal.id === 0) {
            this.$snotify.info('Creating Part', 'Part');
            console.log('creating the part');
            await this.createPart(this.partLocal).catch(() => {
              this.isSaving = false;
            });
            console.log('part created - sending event');
            this.$emit('partCreated', this.partLocal);
            if (this.partLocal.id > 0) {
              this.$snotify.success('Created Part Successfully', 'Part');
            }
          } else {
            this.$snotify.info('Updating Part', 'Part');
            console.log('updating the part');
            await this.updatePart(this.partLocal).catch(() => {
              this.isSaving = false;
            });
            console.log('part updated - sending event');
            this.$emit('partUpdated', this.partLocal);
            if (this.partLocal.id > 0) {
              this.$snotify.success('Updated Part Successfully', 'Part');
            }
          }
          this.isSaving = false;
        }catch (e) {
          this.isSaving = false;
        }
      }
      else{
        this.openAlertBox({message: 'Please correct the errors before saving',title: 'Errors'});
      }
    },
    onCancel() {
      this.$emit('cancel');
    },
    onValueChangePart({ name, value }) {
      this.partLocal = {
        ...this.partLocal,
        [name]: value,
      };
    },
    modalIdGenerator(prop) {
      return this.propForm != null ? `${this.propForm}-${prop}-modal` : `${prop}-modal`
    },
    async getList(partNumber) {
      await this.getPartNumbers(partNumber);

      return this.partNumbers;
    },
    async onSuggestSelect(suggestion) {
      console.log('Part Number Selected', suggestion);
      console.log(Object.keys(this.partLocal).length)
      if (Object.keys(this.partLocal).length > 0) {
        const confirm = await this.openConfirmBox({
          message: 'Are you sure you want to abandon your changes?'
        })

        if (confirm) {
          this.partLocal = {
            ...suggestion,
            id: 0,
            partNumber: this.partNumberProp
          };
          this.$refs.partNumberInput.focus();
        } else {
          this.chosenPartNumber = null;
        }
      } else {
        this.partLocal = {
          ...suggestion,
          id: 0,
          partNumber: this.partNumberProp
        };
        this.$refs.partNumberInput.focus();
      }
    },
    onCopy() {
      this.partLocal = {
        ...this.partLocal,
        id: 0,
        partNumber: null
      };
      this.$emit('partCopy');
    }

  },
  watch: {
    part() {
      //console.log('watching the part');
      this.partLocal = { ...this.part };
    },
  },
	async mounted() {
    if (this.partId != null && this.partId > 0) {
      this.setContainerLoader(true);
      await this.getById(this.partId).then(() => {
        this.setContainerLoader(false);
      }).catch(() => {
        this.setContainerLoader(false);
        //return back to listing page because error in fetch record
        this.$router.push({name: 'parts'});
      });
    }
    if (this.partNumberProp !== "") {
      this.partLocal = {
        ...this.partLocal,
        partNumber: this.partNumberProp
      }
    }

  },
  validations: {
    partLocal: {
      partNumber: { required },
      manufacturerId: { required },
      description: { required },
      inventoryClassId: { required },
      inventoryCategoryId: { required },
      leadFree: { required },
      packageId: { required },
      uoMId: { required }
    },
  },
}
</script>

<style>

</style>
